import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { getDpPortalTabHref } from '../../dpPortal.definitions';
import { useDpPortalTabs } from '../../hooks/useDpPortalTabs';

const FALLBACK_PATH = '/collaborators/directory';

export function DpPortalIndexRedirect() {
    const { tabs, isModuleAccessLoading } = useDpPortalTabs();

    if (isModuleAccessLoading) {
        return <LoadingSpinner />;
    }

    const firstTab = tabs[0];
    return <Navigate to={firstTab ? getDpPortalTabHref(firstTab) : FALLBACK_PATH} replace />;
}
